import React from 'react';
import {
  Container,
  DetailsContainer,
  PlaceholderContainer,
  NameLabel,
  ButtonContainer,
} from './style';
import Placeholder from '../Placeholder';
import Button from '../Button';

interface Props {
  name: string;
  action: string;
}

const TeamListItem: React.FC<Props> = (props) => {
  const { name, action } = props;

  return (
    <Container>
      <PlaceholderContainer>
        <Placeholder />
      </PlaceholderContainer>

      <DetailsContainer>
        <NameLabel>{name}</NameLabel>
      </DetailsContainer>

      <ButtonContainer>
        <Button label={action} />
      </ButtonContainer>
    </Container>
  );
};

export default TeamListItem;
